const featureFlags = {
    AD_CREATE_ENABLED: true,
    AD_LANDING_PAGE_SCREENSHOT_QUEUE_ENABLED: false,
    ALGOLIA_ADS_INDEX: 'development_ADS',
    ALGOLIA_ADS_QUERY_SUGGESTIONS_INDEX: 'development_ADS_query_suggestions',
    ALGOLIA_APP_ID: 'PK8QF2SL4E',
    ALGOLIA_SEARCH_API_KEY: '52728a4d5df179caa40f3781511be937',
    ASSETS_UI: true,
    AZURE_CDN_URL: 'http://127.0.0.1:10000/devstoreaccount1',
    AZURE_STORAGE_ACCOUNT_NAME: 'devstoreaccount1',
    AZURE_STORAGE_CONNECTION_STRING: 'DefaultEndpointsProtocol=http;AccountName=devstoreaccount1;AccountKey=Eby8vdM02xNOcqFlqUwJPLlmEtlCDXJ1OUzFT50uSRZ6IFsuFq2UVErCz4I6tq/K1SZFPTOtr/KBHBeksoGMGw==;BlobEndpoint=http://127.0.0.1:10000/devstoreaccount1;',
    AZURE_STORAGE_SCREENSHOTS_CONTAINER: 'dev-screenshots',
    AZURE_STORAGE_USER_ASSET_CONTAINER: 'dev-userassets',
    BRAND_TRACKING_MODAL: true,
    COMMENTS_COUNT: true,
    COMMENTS_HYDRATE_RELATIONSHIPS: true,
    DISCOVER_PILLS: true,
    FACEBOOK_API_VERSION: 'v18.0',
    FACEBOOK_APP_ID: '1548574282349689',
    FACEBOOK_APP_LOGIN_CONFIG_ID: '345128978470471',
    FACEBOOK_CONNECT_ENABLED: true,
    FIREBASE_CLIENT_EMAIL: 'firebase-adminsdk-x7cj8@magicbrief-development.iam.gserviceaccount.com',
    FIREBASE_PROJECT_ID: 'magicbrief-development',
    FOR_YOU_PAGE: true,
    GTM_CONTAINER_ID: 'GTM-PDGN84FW',
    HOCUSPOCUS_PATH: '/ws2',
    INSIGHTS_UI_ENABLED: true,
    INTERCOM_APP_ID: 'rkw2wymi',
    JOB_AD_SEARCH_INGESTOR_ENABLED: false,
    JOB_AD_SEARCH_INGESTOR_SCHEDULE: '* * * * *',
    JOB_FACEBOOK_DATA_CONVERTER_ENABLED: false,
    JOB_FACEBOOK_DATA_CONVERTER_SCHEDULE: '*/6 * * * *',
    JOB_FACEBOOK_INTEGRATION_AD_INGESTOR_ENABLED: false,
    JOB_FACEBOOK_INTEGRATION_AD_INGESTOR_SCHEDULE: '*/5 * * * *',
    JOB_RELAY_NOTIFICATIONS_RELAY_ENABLED: true,
    JOB_RELAY_NOTIFICATIONS_RELAY_SCHEDULE_SECONDS: 30,
    LANGUAGE_FILTER: true,
    MAGICAI_VERSION: 'no version provided',
    MAGICBRIEF_PRO_PRICE: 'price_1MTvsjEWwTv5JS3xJRDIrSUh',
    MAGICBRIEF_SEAT_PRICE: 'price_1NceJbEWwTv5JS3x7W8O7MX3',
    MAIL_SERVICE_AUTH_USER: 'api',
    MAIL_SERVICE_FROM: 'donotreply@magicbrief.com',
    MAIL_SERVICE_HOST: 'send.smtp.mailtrap.io',
    MAIL_SERVICE_PORT: 587,
    MAILTRAP_SENDER_EMAIL: 'noreply@magicbrief.com',
    MAILTRAP_SENDER_NAME: 'MagicBrief',
    MAILTRAP_TEMPLATE_UUID_BRIEF_INVITE: 'f6160a4f-4ba9-4427-9b66-5580a3c86ff7',
    MAILTRAP_TEMPLATE_UUID_BRIEF_ASSIGNED_UPDATE: 'fa25fd39-4f91-449e-b129-eaf63566cc83',
    MAILTRAP_TEMPLATE_UUID_BRIEF_DUE_DATE_UPDATE: '2844a4a6-9374-4032-bccb-c29d027e23e6',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STAGE_UPDATE: 'e4204a97-f97a-43de-95ee-30fd13e78d0c',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STATUS_UPDATE: 'db4f345c-d77f-4d8c-98ed-0be5d9cdac01',
    MAILTRAP_TEMPLATE_UUID_COMMENT_MENTION: '5a69e27a-bf0e-4a9f-8ea0-e77f3f648f94',
    MAILTRAP_TEMPLATE_UUID_ORGANISATION_INVITE: '9a9891b0-af26-494f-beb6-a8dcca4004ba',
    MB_API_URL: 'http://localhost:12500',
    MB_CLIENT_URL: 'http://localhost:3000',
    MB_SHARE_URL: 'http://localhost:12600',
    /** @todo set this to false after notifications is stable otherwise it will get annoying locally */
    NOTIFICATIONS_EMAIL: true,
    /** @todo set this to false after notifications is stable otherwise it will get annoying locally */
    NOTIFICATIONS_IN_APP: true,
    OPENAI_TOKEN: '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',
    PRESENCES: false,
    REDIS_DB: 15,
    REDIS_HOST: 'localhost',
    REDIS_PORT: 6380,
    RELAY_NOTIFICATIONS_START_DATE: new Date(2023, 10, 27, 0, 0, 0, 0),
    RELAY_NOTIFICATIONS_STRATEGY: 'scheduled',
    SCREENSHOT_FUNCTION_URL: 'http://localhost:7071/api/screenshot',
    SEARCH_ENGINE: 'mb',
    SEARCH_VERSION: 'v2',
    SENTRY_DSN_API: 'https://d580afbde6f84287a869cdd9ef6c254d@o4504063794348032.ingest.sentry.io/4504063806406657',
    SENTRY_DSN_FUNCTIONS: 'https://0c48f78087038d452f91a20cda38ea27@o4504063794348032.ingest.sentry.io/4506057105997824',
    SENTRY_DSN_JOBS: 'https://4d2fbacff9fc394b4a3d0e5bc1cbcdca@o4504063794348032.ingest.sentry.io/4506193515184128',
    SERVER_PORT: 12500,
    SHORT_URL: 'http://localhost:3000',
    SHOW_GPT_BOARDS: true,
    SLACK_WEBHOOK_URL: '',
    SLACK_DEBUG_URL: '',
    SOCKET_IO_PATH: '/ws1',
    TIER_ONE_PRICE_PLAN: 'price_1NFroxFCEWG0XyoSuCbWRvjT',
    TIER_TWO_PRICE_PLAN: 'price_1NFrp8FCEWG0XyoSrB12IDEH',
    USER_HYDRATE_HAS_QUALIFIED_EMAIL: true,
};
export default featureFlags;
//# sourceMappingURL=local.js.map